import React, { Fragment, useState } from 'react';
import Link from 'redux-first-router-link';
import PropTypes from 'prop-types';
import OutboundLink from '../common/OutboundLink';
import Separator from '../common/Separator';
import { SITE_HOST } from '../../consts';

const CorpLinks = ({
  isMobile,
  parent,
}) => {
  const CorpLinkAbout = <a key="careers" className="corp-link" href={`${SITE_HOST}/page/about-us`}>About Us</a>;
  const CorpLinkContact = <OutboundLink key="careers" className="corp-link" href="https://www.gallerymediagroup.com/contact" target="_blank">Contact</OutboundLink>;
  const CorpLinkCareers = <OutboundLink key="careers" className="corp-link" href="https://www.gallerymediagroup.com/careers" target="_blank">Careers</OutboundLink>;
  const CorpLinkAdvertise = <OutboundLink key="advertise" href="https://www.gallerymediagroup.com/advertise" className="corp-link" target="_blank">Advertise</OutboundLink>;
  const CorpLinkInstagramPortfolio = <OutboundLink key="instagram-portfolio" href="https://www.gallerymediagroup.com/social-portfolio" className="corp-link" target="_blank">Instagram Portfolio</OutboundLink>;
  const CorpLinkSitemap = <OutboundLink key="instagram-portfolio" href="https://www.purewow.com/sitemap/html-sitemap" className="corp-link" target="_blank">Sitemap</OutboundLink>;
  const CorpLinkPurewow = <OutboundLink key="purewow" href="https://www.purewow.com/" className="corp-link" target="_blank">Purewow</OutboundLink>;
  const CorpLinkContributor = <Link key="contributor" className="corp-link contributor" to={{ type: 'CONTRIBUTE' }} target="_blank">Become a Contributor</Link>;
  const CorpLinkConditions = <Link key="terms" className="corp-link" to={{ type: 'TERMS' }} target="_blank">Terms &amp; Conditions</Link>;
  const CorpLinkPrivacy = <Link key="privacy" className="corp-link" to={{ type: 'PRIVACY_POLICY' }} target="_blank">Privacy Policy</Link>;
  const CorpLinkEditorial = <Link key="editorial" className="corp-link" to={{ type: 'EDITORIAL_POLICY' }} target="_blank">Editorial Policy</Link>;
  const CorpLinkContests = <Link key="contests" className="corp-link" to={{ type: 'CONTEST_RULES' }} target="_blank">Contests</Link>;
  const CorpLinkDNS = <Link key="dns" className="corp-link" to={{ type: 'PRIVACY' }} target="_blank">Do Not Sell or Share My Information</Link>;

  const [showCompany, setShowCompany] = useState(false);
  const [showLegal, setShowLegal] = useState(false);

  const corpLinks = [
    CorpLinkAbout,
    CorpLinkContact,
    CorpLinkCareers,
    CorpLinkAdvertise,
    CorpLinkInstagramPortfolio,
    CorpLinkSitemap,
    CorpLinkPurewow,
    CorpLinkContributor,
    CorpLinkConditions,
    CorpLinkPrivacy,
    CorpLinkEditorial,
    CorpLinkContests,
    CorpLinkDNS,
  ];

  let renderedCorpLinks = [];

  if (isMobile && parent === 'nav') {
    const navCorpLinks = [
      [
        CorpLinkAbout,
        CorpLinkCareers,
        CorpLinkContact,
        CorpLinkAdvertise,
        CorpLinkInstagramPortfolio,
        CorpLinkSitemap,
        CorpLinkPurewow,
      ],
      [
        CorpLinkConditions,
        CorpLinkPrivacy,
        CorpLinkEditorial,
        CorpLinkContests,
        CorpLinkDNS,
      ],
    ];
    renderedCorpLinks = <Fragment>
        <div className="corp-link-hed company">
          <span>Company</span>
          <div className={`plus-button subnav ${showCompany ? 'expanded' : 'unexpanded'}`} onClick={() => setShowCompany(!showCompany)}></div>
        </div>
        <div className={`sub-corp-links company ${!showCompany ? 'hide' : ''}`}>
          {navCorpLinks[0]}
        </div>
        <div className="corp-link-hed legal">
          <span>Legal</span>
          <div className={`plus-button subnav ${showLegal ? 'expanded' : 'unexpanded'}`} onClick={() => setShowLegal(!showLegal)}></div>
        </div>
        <div className={`sub-corp-links legal ${!showLegal ? 'hide' : ''}`}>
          {navCorpLinks[1]}
        </div>
    </Fragment>;
  }

  if (parent === 'footer') {
    const footerCorpLinks = [
      [
        CorpLinkAbout,
        CorpLinkCareers,
        CorpLinkContact,
        CorpLinkAdvertise,
        CorpLinkInstagramPortfolio,
        CorpLinkSitemap,
      ],
      [
        CorpLinkConditions,
        CorpLinkPrivacy,
        CorpLinkEditorial,
        CorpLinkContests,
        CorpLinkDNS,
      ],
    ];
    renderedCorpLinks = <Fragment>
        <div className="corp-links-content">
          <span className="corp-links-content-hed">Company</span>
          <ul>
            {footerCorpLinks[0].map(link => (<li>{link}</li>))}
          </ul>
        </div>

        <div className="corp-links-content">
          <span className="corp-links-content-hed">Legal</span>
          <ul>
            {footerCorpLinks[1].map(link => (<li>{link}</li>))}
          </ul>
        </div>
      </Fragment>;
  }
  


  return (
    <div className="corp-links">
      {renderedCorpLinks}
    </div>
  );
};

CorpLinks.propTypes = {
  isMobile: PropTypes.bool,
};

export default CorpLinks;
